import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, useCollectionBinding, useContentToken } from '@vibesites/runtime/react';
import { useRevealStyles } from '../hooks/useRevealStyles';
import {
  AmenityColumn,
  AmenitiesStyles,
  stripHtml,
  type Amenity,
  type GalleryPhoto,
} from './AmenitiesShared';

export function CommunityAmenitiesList() {
  const headingRaw = useContentToken('communityamenitieslist.heading');
  const headingText = stripHtml(headingRaw) || 'Community Amenities';

  const items = useCollectionBinding<Amenity>('communityamenitieslist.items', {
    collection: 'amenities',
    filter: { group: 'Community' },
  });

  const photos = useCollectionBinding<GalleryPhoto>('communityamenitieslist.photos', {
    collection: 'photo_gallery',
    filter: { title: 'Community' },
    defaultLimit: 8,
  });

  useRevealStyles();

  return (
    <section className="py-8 md:py-12 bg-[var(--vibe-color-background)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {items.length > 0 ? (
          <AmenityColumn
            headingNode={
              <RichTextContent
                path="communityamenitieslist.heading"
                label="Community Heading"
                defaultValue="<p>Community Amenities</p>"
                as="h3"
                className="amenities-col-heading"
              />
            }
            headingText={headingText}
            items={items}
            photos={photos}
            imagePosition="left"
          />
        ) : (
          <div className="text-center py-12 text-[var(--vibe-color-text-muted)]">
            <p className="font-body text-lg">Community amenities will be displayed here.</p>
          </div>
        )}
      </div>

      <AmenitiesStyles />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CommunityAmenitiesList',
  displayName: 'Community Amenities List',
  tokens: {
    'communityamenitieslist.heading': {
      label: 'Community Heading',
      type: 'richtext',
      defaultValue: '<p>Community Amenities</p>',
    },
  },
  collectionBindings: {
    'communityamenitieslist.items': {
      label: 'Community Amenities',
      collection: 'amenities',
    },
    'communityamenitieslist.photos': {
      label: 'Community Photos',
      collection: 'photo_gallery',
    },
  },
};

(CommunityAmenitiesList as any).contentSchema = contentSchema;

export default CommunityAmenitiesList;
